import React, { useState } from 'react';
import { Link, withRouter } from 'react-router-dom'

import { productosAPI } from '../../../../utils/funcionesAPI'
import {manejadorDeRespuesta} from '../../../../utils/Tools'
import {RUTA_ITINERARIO} from '../../../../utils/rutasFijas'
import { toast } from 'react-toastify'
import whatsapp from '../../../../imagenes/header/whatsapp_negro.png'

const Contenido = (props) => {
  const { producto } = props;
  const { 
    idProducto, 
    destino, 
    dias, 
    noches, 
    transporte = { descripcion: '', codigoCategoria: '' }, 
    multimedia, 
    detalleWeb, 
    regimen, 
    notaAlojamiento, 
    planesFamily, 
    transfer, 
    seguroMedico 
  } = producto;
  const [panelActive, setPanelActive] = useState({
    descripcion: 'show active',
    itinerario: '',
    video: '',
    ubicacion: ''
  });

  const codigoItinerario = destino.idDestino + dias + noches + transporte.descripcion +  transporte.codigoCategoria;
  const video = multimedia.find(m => m.tipoArchivo === 'V');
  const mapa = multimedia.find(m => m.tipoArchivo === 'M');
  let iconoTransporte = '';
  if (transporte.descripcion === 'BUS')
      iconoTransporte = 'directions_bus';

  if (transporte.descripcion === 'AER')
      iconoTransporte = 'airplanemode_active';

  const setStatusOfPanel = (panel) => {
    setPanelActive({
      descripcion: '',
      itinerario: '',
      video: '',
      ubicacion: '',
      [panel]: 'show active'
    })
  };

  function traerItinerario(e) {
      //e.preventDefault();

      let data = JSON.stringify({peticion: 'traerItinerario', codigo: codigoItinerario, origen: props.match.params.origen });

      //let newWindow = window.open("", 'Itinerario', configuracion_ventana);
      productosAPI(data)
              .then(respuesta => {
                if(manejadorDeRespuesta(props, respuesta))
                  if (respuesta.data) {
                    var configuracion_ventana = "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes";
                    const ruta = RUTA_ITINERARIO + props.match.params.origen + '/' + respuesta.data;
                    window.open(ruta, 'Itinerario', configuracion_ventana);
                    setStatusOfPanel('itinerario')
                    //newWindow.location = ruta;
                  } else {
                    toast.info('No hay hay itinerario por el momento', {
                                          position: toast.POSITION.BOTTOM_CENTER
                                          });
                  }

              });
    }

  return (
    <div className="info col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
      <h2>({idProducto}) {detalleWeb} {dias} Dias - {noches} Noches</h2>
      <ul className="nav nav-pills" id="pills-destino" role="tablist">
        <li className="nav-item">
          <Link 
            className={`nav-link ${panelActive.descripcion}`} 
            onClick={() => setStatusOfPanel('descripcion')} 
            id="pills-descripcion-tab" 
            data-toggle="pill" 
            to={`#pills-descripcion-${idProducto}`} 
            role="tab" 
            aria-controls="pills-descripcion"
            aria-selected="false">
              <i className="material-icons">&#xE0B9;</i> Descripci&oacute;n
          </Link>
        </li>
        { idProducto !== 289 && (
          <li className="nav-item">
            <Link 
              className={`nav-link ${panelActive.itinerario}`} 
              to={`#pills-itinerario-${idProducto}`} 
              data-toggle="pill" 
              onClick={traerItinerario} 
              id="pills-itinerario-tab"
              aria-controls="pills-itinerario" 
              aria-selected="false">
                <i className="material-icons">&#xE896;</i> Itinerario
            </Link>
          </li>
        )}
        {video && (
          <li className="nav-item">
            <Link 
              className={`nav-link ${panelActive.video}`} 
              onClick={() => setStatusOfPanel('video')} 
              id="pills-embarque-tab" 
              data-toggle="pill" 
              to={`#pills-video-${idProducto}`}
              aria-selected="false">
                <i className="material-icons">&#xE890;</i> Video
            </Link>
          </li>
        )}
        {mapa && (
          <li className="nav-item">
            <Link 
              className={`nav-link ${panelActive.ubicacion}`} 
              onClick={() => setStatusOfPanel('ubicacion')} 
              id="pills-ubicacion-tab" 
              data-toggle="pill" 
              to={`#pills-ubicacion-${idProducto}`}
              aria-selected="false">
                <i className="material-icons">&#xE890;</i> Ubicaci&oacute;n
            </Link>
          </li>
        )}
      </ul>
      <div className="tab-content" id="pills-destino-content">
      {/*Descripcion */}
      <div className={`tab-pane fade ${regimen.codigo === 'PCF' ? 'sello_allInclusive' : ''} ${panelActive.descripcion}`} id={`pills-descripcion-${idProducto}`} role="tabpanel" aria-labelledby="pills-descripcion-tab">
        <h6>Incluye:</h6>
          { idProducto === 289 && <p><i className="material-icons alineacionIconoContenido">pool</i> Ingreso al predio y acceso a las piscinas</p>  }
          { (regimen.descripcion !== 'SIN REGIMEN' && regimen.descripcion) 
            && <p><i className="material-icons alineacionIconoContenido">restaurant</i> {regimen.descripcion}</p> }   
            { transporte.descripcion !== '' && <p><span><i className="material-icons alineacionIconoContenido">{iconoTransporte}</i> {transporte.descripcion + ' - ' + transporte.categoria}</span></p> }

          { notaAlojamiento !== '' ? <p><i className="material-icons alineacionIconoContenido">business</i> {notaAlojamiento} {planesFamily.length > 0 ? <span><i className="material-icons alineacionIconoContenido">group</i> Plan Family</span> : null }</p> : null }
          { seguroMedico !== '0' ? <p><i className="material-icons alineacionIconoContenido" >local_hospital</i> Asistencia al Viajero { transfer !== '' ? <span><i className="material-icons alineacionIconoContenido">directions_bus</i> {transfer}</span> : null }</p> : null }
          {/*<p><Link to='/reserva-flexible'><i className="material-icons alineacionIconoContenido" >event</i> Reserva Flexible</Link></p>*/}
          <p>
            <img src={whatsapp} width="25" alt="Logo de Whatsapp. Al clickearlo, escribiremos al Whatsapp de Pedraza Viajes"
             srcSet={whatsapp + ' 1x, ' + whatsapp + ' 2x, ' + whatsapp + ' 3x'} />
            <a href={`https://api.whatsapp.com/send?phone=${destino.whatsapp}&text=Hola,%20quisiera%20asesoramiento%20para%20${detalleWeb}%20${dias}D-${noches}N`} target="_blank"
               rel="noopener noreferrer" className="linkWhatsapp">
                Click aquí para consultarnos por Whatsapp
            </a>
          </p>
      </div>
        {/*itinerario */}
        <div 
          className={`tab-pane text-uppercase fade ${panelActive.itinerario}`} 
          id={`pills-itinerario-${idProducto}`} 
          role="tabpanel" 
          aria-labelledby="pills-itinerario-tab"
        >
          <h6>Atenci&oacute;n:</h6>
          <p>Asegurese de tener habilitada la opci&oacute;n Permitir Ventanas emergentes (pop-ups) en su navegador para abrir el Itinerario.</p>
        </div>
        {/*Puerto de Embarque*/}
        {video && (
          <div 
            className={`tab-pane text-uppercase fade ${panelActive.video}`} 
            id={`pills-video-${idProducto}`} 
            role="tabpanel" 
            aria-labelledby="pills-video-tab"
          >
            <p dangerouslySetInnerHTML={{__html: video.url}}></p>
          </div> 
        )}
        {mapa && (
          <div 
            className={`tab-pane text-uppercase fade ${panelActive.ubicacion}`} 
            id={`pills-ubicacion-${idProducto}`} 
            role="tabpanel" 
            aria-labelledby="pills-ubicacion-tab"
          >
            <p dangerouslySetInnerHTML={{__html: mapa.url}}></p>
        </div>
        )}
      </div>
    </div>
  )
}

export default withRouter(Contenido)


/*
{ producto.transporte.descripcion !== '' ? <p><span>TRANSPORTE: </span>{producto.transporte.descripcion + ' - ' + producto.transporte.categoria}</p> : null }
{ producto.regimen.descripcion !== 'SIN REGIMEN' ? <p><span>R&Eacute;GIMEN: </span>{producto.regimen.descripcion}</p> : null }

{ producto.notaAlojamiento !== '' ? <p><span>ALOJAMIENTO: </span>{producto.notaAlojamiento}</p> : null }
{ producto.seguroMedico !== '0' ? <p><span>ASISTENCIA AL VIAJERA: </span>SI</p> : null }
{ producto.transfer !== '' ? <p><span>TRANSFER: </span>{producto.transfer}</p> : null }




        { producto.transporte.descripcion !== '' ? <p>Transporte en <span>{producto.transporte.descripcion + ' - ' + producto.transporte.categoria}</span></p> : null }
        <p>{producto.noches} noches de alojamiento { producto.notaAlojamiento !== '' ? <span>en {producto.notaAlojamiento}</span> : null } { producto.regimen.descripcion !== 'SIN REGIMEN' ? <span>con {producto.regimen.descripcion}</span> : null } </p>
        { producto.seguroMedico !== '0' ? <p>Asistencia al Viajero</p> : null }
        { producto.transfer !== '' ? <p>Translados {producto.transfer}</p> : null }
*/



// WEBPACK FOOTER //
// ./src/components/Resultados/ListadoProducto/ProductoCuadro/Contenido.js